// Real BIGA brand assets (uploaded) — single source of truth.
export const LOGO_URL =
  "https://customer-assets-0z36b82j.emergentagent.net/job_457af2ef-dd8b-46ea-a70e-c1f70bef7135/artifacts/5ca3f5beca7336e9_ChatGPT%20Image%20Oct%2012%2C%202026%2C%2006_18_00%20PM.png";
